// ---インデックス処理---
// 注釈：重複除外やソートの処理のうち、前提として処理をする前に行う必要があるものは、この関数内に記載する。
// 重複削除処理
const deduplicate = function (argList) {
  return argList.filter(function (x, i, self) { return self.indexOf(x) === i })
}

// チェックされた品詞のインデックス抽出処理
const getCheckIndexList = function (argPos1Check, argPos2Check, argPos1, argPos2) {
  let indexPos1 = []
  let indexPos2 = []
  let tempIndex = []
  // チェックされた品詞１の配列のインデックスを抽出
  for (const pick of argPos1Check) {
    tempIndex = argPos1.reduce((results, el, idx) => {
      if (el === pick) { results.push(idx) } return results
    }, [])
    // 品詞のインデックスを結合
    indexPos1 = indexPos1.concat(tempIndex)
  }
  // 品詞２についても同様の処理
  for (const pick of argPos2Check) {
    tempIndex = argPos2.reduce((results, el, idx) => {
      if (el === pick) { results.push(idx) } return results
    }, [])
    indexPos2 = indexPos2.concat(tempIndex)
  }
  // 複数パートの結合
  return indexPos1.concat(indexPos2)
}

// 連続する数値のみ抽出
const getContinuumList = function (argIndexList) {
  // ソートと重複排除
  let conList = deduplicate(argIndexList).sort((a, b) => a - b)
  conList = conList.filter((value, index, array) => {
    return (array.includes(value - 1) || array.includes(value + 1)) === true
  })
  return conList
}

// 検索文字を含む配列の作成
const getSchIndex = function (argListSurf, argcheckIndex, argtextCont) {
  // 形態素のうち検索テキストに合致するインデックス番号を取得
  const schIndex = argListSurf.reduce((results, el, idx) => {
    if (el === argtextCont) { results.push(idx) } return results
  }, [])
  // 検索文字のインデックス番号を選択したインデックスに追加
  argcheckIndex = deduplicate(schIndex.concat(argcheckIndex).sort((a, b) => a - b))
  return argcheckIndex
}

const getSchIndexOnly = function (argListSurf, argcheckIndex, argtextCont) {
  // 形態素のうち検索テキストに合致するインデックス番号を取得
  const schIndex = argListSurf.reduce((results, el, idx) => {
    if (el === argtextCont) { results.push(idx) } return results
  }, [])
  // 検索文字のインデックス番号を選択したインデックスに追加
  argcheckIndex = getContinuumList(schIndex.concat(argcheckIndex)).sort((a, b) => a - b)
  // schIndexと連続するもののみ抽出
  let tempList = []
  let schIncludeList = []
  let tempFlag = false
  argcheckIndex.filter((value, index, array) => {
    if (schIndex.includes(value) === true) { tempFlag = true }
    if (array.includes(value + 1) === true) {
      tempList.push(value)
    } else if (tempFlag === true) {
      tempList.push(value)
      schIncludeList = schIncludeList.concat(tempList)
      tempList = []
      tempFlag = false
    } else { tempList = [] }
  })
  return schIncludeList
}

export default {
  getCheckIndexList,
  getContinuumList,
  getSchIndex,
  getSchIndexOnly,
  deduplicate,
}
